import React, {FC} from 'react';
import {EditPenIcon} from 'components';

export const PaymentCard: FC<{
  title: string;
  rate: string;
  rateType?: string;
  onClick: () => void;
}> = ({title, rate, rateType, onClick}) => {
  return (
    <div className="flex flex-row justify-between px-6 py-7 border rounded-xl">
      <div className="flex flex-col gap-4">
        <h5 className="font-inter text-lg leading-5 font-semibold capitalize">
          {title}
        </h5>
        <div className="flex flex-col">
          <p className="font-inter text-2xl leading-8 font-bold">{rate}</p>
          {rateType ? (
            <span className="flex font-inter text-base font-medium leading-5 text-darkGray">
              {rateType}
            </span>
          ) : null}
        </div>
      </div>
      <button
        className="self-center w-11 h-11 flex justify-center items-center bg-[#FFF7E6] hover:border hover:border-[#ffebbf] rounded-2xl"
        onClick={onClick}
      >
        <EditPenIcon />
      </button>
    </div>
  );
};
